import Boundary from "./boundary";

class Model extends Boundary {
    modelId;

    constructor(props) {
        super();
        this.modelId = this.trainingModelIdToModelResourceId(props.id);
        this._addHandlers();
        this.updateBoundingBox();
    }

    _addHandlers() {
        addHandlerForOperation(this.modelId, [this.modelId], this.updateBoundingBox.bind(this), this.modelId + "boundary",
            HANDLER_TYPE_ENUM.BOUNDARY, HANDLER_TYPE_ENUM.BOUNDARY);
    }

    updateBoundingBox() {
        const boxHelper = BoundingBoxFeatureManager.getModelBoundingBox([this.modelId]);
        if (boxHelper) {
            wv.rootObject.localToWorld(boxHelper.box.min);
            wv.rootObject.localToWorld(boxHelper.box.max);
            this.bBox.copy(boxHelper.box);
        }
    }

    trainingModelIdToModelResourceId(trainingModelId) {
        const currentTraining = TrainingTreeController._trainingFeature.getActiveTraining();
        const resources = currentTraining.resources;
        return trainingModelId && resources ? resources[trainingModelId]?.resourceId : null;
    }
}

export default Model;
